module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0059.jpg?v=a6fe7155";